import SupplierAppConnectionSuccessModal from './SupplierAppConnectionSuccessModal'

export default SupplierAppConnectionSuccessModal
